import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@rossum/ui/material';

type Props = {
  onClick: () => void;
  queueName: string;
  selected: boolean;
};

export const Queue = ({ queueName, selected, onClick }: Props) => (
  <ListItem disablePadding>
    <ListItemButton
      onClick={onClick}
      sx={{ pl: 4, py: 0 }}
      data-cy={`queue-menu-item-${queueName.replaceAll(' ', '-')}`}
      data-selected={selected}
      aria-selected={selected}
    >
      <Checkbox checked={selected} />
      <ListItemText
        primary={
          <Typography
            variant="body2"
            title={queueName}
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {queueName}
          </Typography>
        }
      />
    </ListItemButton>
  </ListItem>
);
